import { RootState } from '../reducers/root.reducer';

export const getServerDateTime = (state: RootState) =>
	state.dateTime.currentDateTime;
